import React from 'react';

interface IFormBWizardContext {
  wizard: any;
  selectedValue: string | undefined;
  onSelect: (value: string) => void;
  isOtherIndustry: boolean;
  otherIndustry: string | undefined;
  onOtherIndustryChange: (value: string) => void;
  canProceed: boolean;
  showBackButton: boolean;
  showNextButton: boolean;
  showSubmitButton: boolean;
}

export const FormBWizardContext = React.createContext<IFormBWizardContext>({
  wizard: undefined,
  selectedValue: undefined,
  onSelect: () => undefined,
  isOtherIndustry: false,
  otherIndustry: undefined,
  onOtherIndustryChange: () => undefined,
  canProceed: false,
  showBackButton: false,
  showNextButton: false,
  showSubmitButton: false,
});
